import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';

// Catch "Timeout" (e.g. from ReCAPTCHA script load or API) so the overlay doesn't show.
// ErrorBoundary will show the friendly UI (it listens for the event once mounted).
window.addEventListener('unhandledrejection', (event) => {
  const message =
    typeof event.reason?.message === 'string'
      ? event.reason.message
      : String(event.reason ?? '');
  if (
    message === 'Timeout' ||
    message.toLowerCase().includes('timeout') ||
    message.toLowerCase().includes('network')
  ) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('react-global-timeout-error'));
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
